<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-show-search-member-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalSearchMember"
    ></button>
    <div
      class="modal fade"
      id="modalSearchMember"
      tabindex="-1"
      aria-labelledby="modalSearchMemberLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalSearchMemberLabel">
              Search Member
            </h5>
            <i
              style="cursor: pointer"
              class="material-icons justify-content-end btn-close-modal-search-member"
              data-bs-dismiss="modal"
              aria-label="Close"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div
              class="input-group d-flex align-items-center position-relative"
            >
              <label for="search-input" class="text-bold">Phone Number</label>
              <input
                v-model="phoneNumber"
                type="text"
                class="form-control search-input"
                placeholder="Enter Phone Number"
                style="
                  border-radius: 5px;
                  padding: 10px;
                  padding-right: 40px;
                  border: 1px solid #ddd;
                  width: 100%;
                  font-size: 14px;
                  direction: ltr !important;
                  text-align: left !important;
                  background-color: #fff;
                "
                @keyup.enter="searchMember"
              />
            </div>
            <div class="is-invalid" v-if="errorMessage">{{ errorMessage }}</div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-close-modal btn-sm"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-success btn-background btn-sm"
              @click="searchMember"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardService from "@/services/dashboard.service";
import $ from "jquery";

export default {
  name: "ModalSearchMember",
  props: {
    keyReload: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      phoneNumber: "",
      errorMessage: "",
    };
  },
  methods: {
    async searchMember() {
      this.errorMessage = "";
      if (this.phoneNumber === "" || this.phoneNumber === null) {
        this.errorMessage = "Phone Number is required";
        return;
      }

      let formData = {
        phone_number: this.phoneNumber,
      };

      await DashboardService.searchMember(formData)
        .then((response) => {
          if (response.data.result.isSuccess) {
            $('.btn-close-modal').click();
            const member = response.data.data;
            window.open(`/member/${member.id}`, '_blank');
          } else {
            this.errorMessage = response.data.result.message;
          }
        })
        .catch((error) => {
          this.errorMessage = error.response.data.result.message;
        });
    },
  },
  watch: {
    keyReload: {
      handler() {
        this.phoneNumber = "";
        this.errorMessage = "";
        setTimeout(() => {
          $('.search-input').focus();
        }, 500)
        
      },
    },
  },
};
</script>
